import { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/NavBar.css";

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // New state for mobile toggle

  const closeMenus = () => {
    setIsDropdownOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="sticky top-0 z-[1000] w-full bg-white/80 backdrop-blur-md border-b border-neutral-100 px-6 md:px-16 py-4 transition-all duration-300">
      <div className="flex justify-between items-center">
        
        {/* 🏛️ Brand Identity */}
        <Link to="/" className="flex flex-col group" onClick={closeMenus}>
          <span className="text-[14px] md:text-[16px] font-['Playfair_Display'] tracking-[0.3em] uppercase text-neutral-900 group-hover:text-pink-400 transition-colors">
            Branding & Events
          </span>
          <span className="text-[9px] tracking-[0.5em] uppercase text-neutral-400 -mt-1 font-sans">
            Studio
          </span>
        </Link>

        {/* 🧭 Desktop Navigation Links */}
        <div className="hidden lg:flex items-center gap-10">
          <Link to="/" className="nav-link-item">Home</Link>

          <div 
            className="relative group py-2"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <span className="nav-link-item cursor-pointer flex items-center gap-1">
              Event Packages <span className="text-[8px] opacity-50 group-hover:rotate-180 transition-transform">▼</span>
            </span>

            <div className={`absolute top-full left-1/2 -translate-x-1/2 w-48 bg-white border border-neutral-100 rounded-2xl shadow-2xl p-4 transition-all duration-300 origin-top ${isDropdownOpen ? "opacity-100 scale-100" : "opacity-0 scale-95 pointer-events-none"}`}>
              <div className="flex flex-col gap-1">
                <Link to="/packages/weddings" className="dropdown-item" onClick={closeMenus}>Weddings</Link>
                <Link to="/packages/birthdays" className="dropdown-item" onClick={closeMenus}>Birthdays</Link>
                <Link to="/packages/corporate" className="dropdown-item" onClick={closeMenus}>Corporate</Link>
                <Link to="/packages/special" className="dropdown-item" onClick={closeMenus}>Special Event</Link>
                {/* <Link to="/packages/other" className="dropdown-item" onClick={closeMenus}>Other</Link> */}
              </div>
            </div>
          </div>

          <Link to="/online-store" className="nav-link-item">Online Store</Link>
          <Link to="/our-team" className="nav-link-item">Our Team</Link>
          <Link to="/contact" className="nav-link-item">Contact</Link>
        </div>

        {/* 📱 Social Icons */}
        <div className="hidden md:flex items-center">
          <ul className="wrapper">
            <a href="https://www.instagram.com/brandingevents_studio" target="_blank" rel="noopener noreferrer">
              <li className="icon instagram"><span><svg
      xmlns="http://www.w3.org/2000/svg"
      height="1.2em"
      fill="currentColor"
      class="bi bi-instagram"
      viewBox="0 0 16 16"
    >
      <path
        d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
      ></path>
    </svg></span></li>
              
            </a>
            <a href="https://www.facebook.com/profile.php?id=61586930339814" target="_blank" rel="noopener noreferrer">
              <li className="icon facebook"><span><svg
      viewBox="0 0 320 512"
      height="1.2em"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
      ></path>
    </svg></span></li>
            </a>
            <a href="https://www.tiktok.com/@brandingevents_studio" target="_blank" rel="noopener noreferrer">
              <li className="icon tiktok"><span><svg
  viewBox="0 0 448 512"
  height="1.2em"
  fill="currentColor"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M448,209.9a210.1,210.1,0,0,1-122.8-39.3V349.4A162.6,162.6,0,1,1,185.7,188V278.2a74.7,74.7,0,1,0,52.2,71.2V0h88.3a121.2,121.2,0,0,0,121.8,108.9Z"
  ></path>
</svg>
</span></li>
            </a>
          </ul>
        </div>

        {/* ☰ Mobile Toggle Button */}
        <button 
          className="lg:hidden text-neutral-900 text-2xl focus:outline-none"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* 📱 Mobile Menu Dropdown */}
      <div className={`lg:hidden transition-all duration-500 overflow-hidden ${isMobileMenuOpen ? "max-h-screen opacity-100 pt-6 pb-4" : "max-h-0 opacity-0"}`}>
        <div className="flex flex-col gap-6 items-center bg-white/90 backdrop-blur-lg rounded-3xl p-8 shadow-inner">
          <Link to="/" className="nav-link-item text-lg" onClick={closeMenus}>Home</Link>
          <Link to="/packages/weddings" className="nav-link-item text-lg" onClick={closeMenus}>Weddings</Link>
          <Link to="/packages/birthdays" className="nav-link-item text-lg" onClick={closeMenus}>Birthdays</Link>
          <Link to="/packages/corporate" className="nav-link-item text-lg" onClick={closeMenus}>Corporate</Link>
          <Link to="/packages/special" className="nav-link-item text-lg" onClick={closeMenus}>Special Events</Link>
          {/* <Link to="/packages/special" className="nav-link-item text-lg" onClick={closeMenus}>Other</Link> */}
          <Link to="/online-store" className="nav-link-item text-lg" onClick={closeMenus}>Online Store</Link>
          <Link to="/our-team" className="nav-link-item text-lg" onClick={closeMenus}>Our Team</Link>
          <Link to="/contact" className="nav-link-item text-lg" onClick={closeMenus}>Contact</Link>
        </div>
      </div>
    </nav>
  );
}